import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { adminWishListItems, adminWishlistResponse, CreateWishlistInput, GetWishlistCategoriesResponse, GetwishProductIds, OneWishlistResponse, SubmitResponse, WishlistCategoriesResponse, WishlistCategory, WishlistProductByCategory, WishlistProductRes, WishlistResponse } from '../../models';
import { CreateWishlistCategoryInput, RemoveWishlistInput, SetDefaultWishlistCategoryInput, UpdateWishlistCategoryInput, WishlistInput } from '../../inputs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class WishlistService extends HttpService<
  WishlistInput | CreateWishlistCategoryInput | UpdateWishlistCategoryInput | SetDefaultWishlistCategoryInput | '' | RemoveWishlistInput,
  WishlistResponse | OneWishlistResponse | adminWishListItems
> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'wishlist');
  }

  // Wishlist
  getWishlistCatogory(): Observable<GetWishlistCategoriesResponse> {
    return this.getAll().pipe(catchError((error) => of(error)));
  }


  deleteWishlistItem(wishlistId: string): Observable<SubmitResponse> {
    return this.delete(wishlistId).pipe(catchError((error) => of(error)));
  }

  // Wishlist Category
  addWishlistCategory(input: CreateWishlistCategoryInput): Observable<SubmitResponse> {
    return this.create(input, 'category').pipe(catchError((error) => of(error)));
  }

  updateWishlistCategory(input: UpdateWishlistCategoryInput): Observable<SubmitResponse> {
    return this.update(input, 'category').pipe(catchError((error) => of(error)));
  }

  setAsDefaultWishlistCategory(input: SetDefaultWishlistCategoryInput): Observable<SubmitResponse> {
    return this.update(input, 'category/set-default').pipe(catchError((error) => of(error)));
  }

  deleteWishlistCategory(wishlistCategoryId: string): Observable<SubmitResponse> {
    return this.delete(wishlistCategoryId, 'category').pipe(catchError((error) => of(error)));
  }


  // new 

  getWishlistsV1(): Observable<WishlistCategory[]> {
    return this.getAll().pipe(catchError((error) => of(error)));
  }

  createWishlist(createData: CreateWishlistInput): Observable<GetWishlistCategoriesResponse> {
    return this.create(createData).pipe(catchError((error) => of(error)));
  }

  updateWishlist(updateData: CreateWishlistInput, id: string): Observable<GetWishlistCategoriesResponse> {
    return this.update(updateData, String(id)).pipe(catchError((error) => of(error)));
  }
  setDefaultWishlist(id: string): Observable<GetWishlistCategoriesResponse> {
    return this.update('', id + '/set-default').pipe(catchError((error) => of(error)));
  }

  deleteWishlist(id: string): Observable<GetWishlistCategoriesResponse> {
    return this.delete(id).pipe(catchError((error) => of(error)));
  }

  // wishlist products

  getWishlistProductsIds(): Observable<string[]> {
    return this.getAll('product-variant-ids').pipe(catchError((error) => of(error)));
  }

  getWishlistProductsV1(id: string, page?: number, limit: number = 9): Observable<WishlistProductByCategory> {
    return this.getAllPaged(id, page, '', limit).pipe(catchError((error) => of(error)));
  }

  addToWishlist(input: WishlistInput, wishlistCategoryId: string): Observable<SubmitResponse> {
    return this.create(input, wishlistCategoryId).pipe(catchError((error) => of(error)));
  }
  moveToWishlist(input: WishlistInput, wishlistSourceId: string, wishlistTargetId: string): Observable<SubmitResponse> {
    return this.create(input, wishlistSourceId + "/move-item-to/" + wishlistTargetId).pipe(catchError((error) => of(error)));
  }
  removeFromWishlist(input: RemoveWishlistInput, wishlistProductId: string): Observable<SubmitResponse> {
    return this.update(input, "item/" + wishlistProductId).pipe(catchError((error) => of(error)));
  }
  removeItemFromWishlist(input: string, wishlistProductId: string): Observable<SubmitResponse> {
    return this.delete('', input + "/" + wishlistProductId).pipe(catchError((error) => of(error)));
  }

  getAdminWishlists(page: number): Observable<adminWishlistResponse> {
    return this.getAllPaged('admin',  page ).pipe(catchError((error) => of(error)));
  }

  getAdminWishListsByName(query: string, page: number): Observable<adminWishlistResponse> {
    return this.getAllPaged('admin', page, 'search=' + query).pipe(catchError((error) => of(error)));
  }

  getFilteredWishlists(payload:any): Observable<adminWishListItems> {
    return this.getSearchPages(payload).pipe(catchError((error) => of(error)));
  }
  getWishlistsByProId(proId:string): Observable<WishlistProductRes[]> {
    return this.getAll('by-product/'+proId).pipe(catchError((error) => of(error)));
  }

}
